
const English = {
  translation: {
    header: {
      roleManagement: 'Role Management',
      testingPersonel: 'Testing Personnel',
      accountManagement: 'Account management',
      accountDetails: 'Account details',
      signout: 'Sign out',
      loginRegister: "Login/Register",
      Login: "Login"

    },
    sidebar: {
      dashboardLink: 'Dashboard',
      contactUsLink: 'Contact us',
      websiteLink: 'Website',
      newsLink: "CCO News",
      resourcesLink: "Resources",
      storeLink: "CCO Store",

    },
    dashboard: {

      profileCard: {
        pendingApproval: "PENDING APPROVAL",
        updatePhoto: "Update Photo",
        uploadphoto: "Submit Selfie Now",
        ccoId: ' CCO ID',
        address: "Address",
        phone: 'Phone',
        email: 'Email',
      },
      pendingRequestBanner: {
        part1: "You have a pending request to connect.",
        click: "Click here",
        part2: "to review the request."
      },
      myCertificationCard: {
        MyCertifications: "My Certifications",
        Status: "Status",
        ExpDate: "Exp Date",
        noCertifications: 'No Certifications available',
        cardOrder: "Order Replacement Card",
        cardOrderHover: "Submit Photo to order card.",
        Statuses: {
          Active: "Active",
          Suspended: "Suspended",
          Revoked: "Revoked",
          Inactive: "Inactive",
          Approved: "Approved",
          Pending: "Pending",
          PendingRecert: "PendingRecert",
          Expired: "Expired"
        },
        shareModal: {
          title: "Share myCCO Certifications",
          shareButton: "Share",
          copyButton: "Copy",
          shareSubject: "CCO Certification details for {{name}}",
          shareMessage: " Click link to view current CCO certification status for {{name}} :{{url}}",
          copiedMessage: "Link copied to clipboard!",
          howToShare: "How would you like to share?",
          shareAll: "Share All",
          shareSelected: "Share Selected",
          selectCertifications: "Select the certification you want to share",
          back: "← Back",
          next: "Next →",
          shareToFeed: "Share to Feed",
          addToProfile: "Add to Profile",
        }
      },
      examHub: {
        heading: "myCCO Exam Hub",
        title: "Inside the myCCO Hub, you can:",
        item1: "Find written and practical test locations",
        item2: "See your exams that are available for scheduling",
        item3: "Schedule/Change exam appointments",
        item4: "View your Exam Results",
        ExamHubButton: "Launch myCCO Exam Hub",
        examHubHover: "Go to myCCO Exam Hub to:\nFind EOT or TCT or Practical Test Centers\nSee your exams that are ready to schedule\nChange or cancel exam appointments\nView your Exam Results"
      },
      welcomeUser: 'Welcome to the Dashboard',
      login: 'Log in',
      hello: 'Hi {{name}},',
      applyNow: 'Apply Now For',
      learnLinkLabel: 'Learn about written testing options',
      writingTestButton: 'Submit Written Applications',
      writingTestHover: 'Apply to take CCO written exams either for yourself or on behalf of other candidates',
      practicalTestButton: 'Submit Practical Applications',
      practicalTestHover: 'Apply to take CCO practical exams either for yourself or on behalf of other candidates',
      candidateResources: 'Candidate Resources',
      demoExamHeading: "Test drive CCO's demo exam",
      demoExamDescription: "So that you are prepared for test day, familiarize yourself with CCO's exam delivery system. You can get comfortable with the exam layout, try out the on-screen calculator, navigate on-screen load charts, and more.",
      demoExamButton: 'Test Drive a Written Demo Exam',
      startDemo: 'Start Demo',
      heading: 'to OPT or EOT testing? Take a test drive!',
      paragraph: ' Familiarize yourself with CCO’s new exam delivery system. CCO has created a free demo exam allowing you to navigate then exam delivery system and try out the on-screen calculator, working with load chart PDF files, reviewing/flagging questions, and more.',
      certificate: 'My Certifications',
      para2: 'No certificates found',
      schedule: 'Upcoming Exams / Pending Results',
      para3: 'No upcoming exams found',
      para4: '*Examination results are subject to CCO determinations of validity and other appropriate corrections.',
      para5: 'No history exams found',
      head2: '  Exam History *',
      h2detail: 'previous 12 months',
      button1: 'Written Testing - EOT/OPT'
    },
    account: {
      incompleteProfile: "Complete your profile now to access your CCO ID and submit an exam application.",
      pageHeading: "Account Details",
      personalInfo: "1. Personal Information",
      employeeInfo: "2. Employer Information",
      personalForm: {
        fullName: "Full Name",
        dob: "Date of Birth",
        email: "Email",
        mobilePhone: "Mobile Phone",
        street1: "Street 1",
        street2: "Street 2",
        country: "Country",
        noCountry: "No countries found. Please try again later.",
        city: "City",
        state: 'State',
        selectCountry: 'Select a country first',
        noState: 'No states found. Please try again later.',
        selectState: 'Select a state',
        selectaCountry: 'Select a country',
        zip: "Zip",
        language: "Preferred Language",
        selectLanguage: "Select a language",
        noLanguage: "No languages found. Please try again later.",
      },
      employeeForm: {
        organization: "Organization",
        phone: "Phone",
        address1: "Address 1",
        address2: "Address 2",
        country: "Country",
        noCountry: "No countries found. Please try again later.",
        city: "City",
        zip: "Zip",
      },
      successMessage: "Successfully updated your account, click Return to Dashboard button to continue.",
      saving: "Saving...",
      saveChangesButton: "Save Changes",
      returnDashboardButton: "Return to Dashboard"
    },
    testingPersonnel: {
      pageHeading: "Testing Personnel",
      ccoId: "CCO ID",
      noCredential: "No Credentials available",
      credentialJourneyButton: "Start Credential Journey",
      availableCredentialButton: "View all Available Credentials",
      DescriptionPart1: "Welcome to the myCCO Testing Personnel Portal—your hub for organizing and administering CCO exams. Use this portal to apply for and renew credentials and test sites, create and manage test administrations, and access resources.\n\nOnce credentialed, this portal provides you with access to apply for new test sites, schedule test administrations, register candidates, and proctor exams. Your permissions will depend on the credentials you earn. For more details on each role, ",
      DescriptionLinkText: " click here",
      DescriptionPart2: ".\n\nTo get started, click “Start Credential Journey,” select your desired credential, and follow the steps to qualify."
      ,
      shareModal: {
        title: "Share myCCO Credentials",
        shareButton: "Share",
        copyButton: "Copy",
        shareSubject: "{{name}} is sharing their CCO credentials",
        shareMessage: "{{name}} is sharing their CCO credentials with you. Click here to view their current credential status: {{url}}",
        copiedMessage: "Link copied to clipboard!",
      }
    },
    myCredential: {
      breadcrumbsLink: "Testing Personnel",
      status: "Status",
      expiryLabel: "Training Due",
      noExpiry: "Not Available",
      pendingAuditMessage: "Contact CCO to schedule your audit.",
      pendingCertification: "You must complete your certification in order to earn your credential.",
      renewButton: "Renew Now",
      workshopTitle: "Workshops",
      startEnd: "Start Date/Time",
      name: "Name",
      launchLink: "LaunchLink",
      location: "Location",
      noWorkshop: "No workshop applications available",
      description: "Description",
      manageMyTestAdministrations: "Manage My Test Administrations",
      Resources: "Resources",
      paperPencilTesting: "Written Testing - PPT",
      Statuses: {
        Pending: "Pending",
        PendingAudit: "Pending Audit",
        Inactive: "Inactive",
        PendingCertification: "Pending Certification",
        Approved: "Approved",
        Expired: "Expired",
        HOLD: "Hold",
        Retired: "Retired",
        PendingRenewal: "Pending Renewal"
      },
      workshopStatuses: {
        Active: "Active",
        Inactive: "Inactive",
        Pending: "Pending",
        Approved: "Approved",
        Attended: "Attended",
        Completed: "Completed"
      }
    },
    Credential: {
      testingPersonel: 'Testing Personnel',
      JourneyStatus: '  Journey Status',
      PreReq: {
        WrittenExamText1: 'Written Exam Required',
        WrittenExamText2: 'Click here to sign up',
        ExamStatus: 'Status',
        ExamTestDate: 'Test Date',
        CertificationText1: 'Certification Required',
        CertificationText2: 'Click here to sign up',
        CertExpirationDate: 'Expiration Date',
        PreReqStatus: 'Status:',
        PreReqExpirationDate: 'Expiration Date: ',
        NotPurchased: ' Not Purchased',
        PreReqPara: 'There are no pre-requisites for',
        PreReqPara2: 'credential.',
      },
      BillingInfo: {
        billinginfo: 'Billing Information',
        billingNote: 'Note: We Accept VISA, MasterCard, and American Express.',
        CardNumber: 'Credit Card Number',
        TypeCreditCard: 'Credit Card',
        Error: 'Something went wrong',
        CloseWorkshopPara: 'No closed workshop available against this',
        CloseWorkshopPara2: 'access code.',
        Process: 'Processing',
        Pay: 'Pay $',
        AccessCodefield: 'Enter access code',
        AccessCode: 'Access Code',
        Loading: 'Loading',
        billingbuttonText: 'Click here to fill Credit Card Information',
        formbuttonText: 'Continue',
        formHeaderText: 'Payment',
        Cardinfo: ' Please fill credit card information!',
        FirstNamefield: ' First Name',
        LastNamefield: ' Last Name',
        Emailfield: ' Email',
        Phonefield: 'Phone',
        Countryfield: 'Country',
        Addressfield: 'Address',
        Cityfield: 'City',
        Statefield: 'State',
        Zipfield: 'Zip',
        SuccessResponse: 'Request submited successfully.',
      },

      CredentialInfo: 'Credential Information',
      CredentialEmpty: 'Credential information is empty',
      Workshop: {
        AvailableWorkshop: 'Available Workshops',
        WorkshopError: 'You must select one workshop to proceed.',
        Startdate: 'Start Date/Time*',
        Enddate: 'End Date/Time*',
        Location: 'Location',
        AvailableSeats: 'Available Seats',
        ApplicationDeadline: 'Application Deadline',
        AuditEvent: 'Audit Event',
        WorkshopPara1: ' Sorry, there are currently no available workshops. You are not able to continue until a workshop becomes available. If you`d like to be added to the waitlist, please email',
        WorkshopPara2: 'Provide your name, CCO ID, and indicate which workshop you are interested in attending. We will notify you when additional workshops are added.',
      },
      Agreement: 'Agreement',
      termsandCondition: '  I understand and agree to this Agreement. I further understand and agree that a payment to register or enroll in any testing personnel training (such as a course or a workshop) cannot be refunded once my request and payment are submitted to CCO. In addition, I understand that  any such registration cannot be cancelled or transferred. By submitting a payment, I agree to CCO `s',
      FinancialTerms: ' Financial Terms and Conditions',
      ProceedtCheckout: ' Proceed to checkout',
      Submit: 'Submit',
      Title: 'Please wait while payment is processed. Do not refresh page or click back button.'
    },
    CredentialRenewal: {
      testingPersonel: 'Testing Personnel',
      JourneyStatus: '  Journey Status',
      WrittenExamText1: 'Written Exam Required',
      WrittenExamText2: 'Click here to sign up',
      ExamStatus: 'Status',
      ExamTestDate: 'Test Date',
      CertificationText1: 'Certification Required',
      CertificationText2: 'Click here to sign up',
      CertExpirationDate: 'Expiration Date',
      PreReqStatus: 'Status:',
      PreReqExpirationDate: 'Expiration Date: ',
      NotPurchased: ' Not Purchased',
      PreReqPara: 'There are no pre-requisites for',
      PreReqPara2: 'credential.',
      billinginfo: 'Billing Information',
      billingNote: 'Note: We Accept VISA, MasterCard, and American Express.',
      CardNumber: 'Credit Card Number',
      TypeCreditCard: 'Credit Card',
      Error: 'Something went wrong',
      CloseWorkshopPara: 'No closed workshop available against this',
      CloseWorkshopPara2: 'access code.',
      Process: 'Processing',
      Pay: 'Pay $',
      AccessCodefield: 'Enter access code',
      AccessCode: 'Access Code',
      Loading: 'Loading',
      billingbuttonText: 'Click here to fill Credit Card Information',
      formbuttonText: 'Continue',
      formHeaderText: 'Payment',
      Cardinfo: ' Please fill credit card information!',
      FirstNamefield: ' First Name',
      LastNamefield: ' Last Name',
      Emailfield: ' Email',
      Phonefield: 'Phone',
      Countryfield: 'Country',
      Addressfield: 'Address',
      Cityfield: 'City',
      Statefield: 'State',
      Zipfield: 'Zip',
      SuccessResponse: 'Request submited successfully.',
      CredentialInfo: 'Credential Information',
      CredentialEmpty: 'Credential information is empty',
      AvailableWorkshop: 'Available Workshops',
      WorkshopError: 'You must select one workshop to proceed.',
      Startdate: 'Start Date/Time*',
      Enddate: 'End Date/Time*',
      Location: 'Location',
      AvailableSeats: 'Available Seats',
      ApplicationDeadline: 'Application Deadline',
      AuditEvent: 'Audit Event',
      WorkshopPara1: ' Sorry, there are currently no available workshops. You are not able to continue until a workshop becomes available. If you`d like to be added to the waitlist, please email',
      WorkshopPara2: 'Provide your name, CCO ID, and indicate which workshop you are interested in attending. We will notify you when additional workshops are added.',
      Agreement: 'Agreement',
      termsandCondition: '  I understand and agree to this Agreement. I further understand and agree that a payment to register or enroll in any testing personnel training (such as a course or a workshop) cannot be refunded once my request and payment are submitted to CCO. In addition, I understand that  any such registration cannot be cancelled or transferred. By submitting a payment, I agree to CCO `s',
      FinancialTerms: ' Financial Terms and Conditions',
      ProceedtCheckout: ' Proceed to checkout',
      Submit: 'Submit',
      Title: 'Please wait while payment is processed. Do not refresh page or click back button.',
      Renew: 'Renew',
      AuthorizedError: 'Our records indicate that you are not authorized to access this page. Please contact CCO if you have any questions. ',
      NotRenewed: ' Not Renewed',
      NotAvailable: 'Not Available',
      ProductError: 'Credential product fee not found!'
    }
    , credentialjourney: {
      CredentialJourney: "Credential Journey",
      testingPersonnel: "Testing Personnel",
      SelectJourneyButton: "Select your Credential journey",
    },
    CAD: {
      CadManagement: {
        pageHeading: "Testing Personnel",
        ccoId: "CCO ID",
        PracLocations: 'Practical Locations',
        CustomCaD: 'My Custom CADs',
        BacktoPrac: 'Back to Prac Test Site',
        AddnewCad: 'Add new Custom CADs',
        PendingCad: 'My Pending Review Custom CADs',
        ApproveCad: 'My Approved Custom CADs',
        CompleteCad: 'My Completed Custom CADs',
        ExpireCad: 'My Expired Custom CADs',
        NoCustomCad: 'No Custom CADs found',
      },
      BillingInformation: {
        billinginfo: 'Billing Information',
        billingNote: 'Note: We Accept VISA, MasterCard, and American Express.',
        CardNumber: 'Credit Card Number',
        TypeCreditCard: 'Credit Card',
        Error: 'Something went wrong',
        Process: 'Processing',
        Pay: 'Pay $',
        billingbuttonText: 'Click here to fill Credit Card Information',
        formbuttonText: 'Continue',
        formHeaderText: 'CAD Payment',
        Cardinfo: 'It`s compulsory to fill credit card information first',
        FirstNamefield: ' First Name',
        LastNamefield: ' Last Name',
        Emailfield: ' Email',
        Phonefield: 'Phone',
        Countryfield: 'Country',
        Addressfield: 'Address',
        Cityfield: 'City',
        Statefield: 'State',
        Zipfield: 'Zip'
      },
      CADlanding: {
        OptionYes: 'Yes',
        OptionNo: 'No',
        descrip1: 'Is your test weight anything other than 3 ft. outside diameter?',
        descrip1_2: "Is the capacity of the crane less than the test weight range for the applicable standard CAD?",
        for1: "For All Mobile Cranes:",
        descrip2: "Does your crane have rear outrigger spread of greater than 24 ft.?",
        for2: "For Boom Trucks:",
        descrip3: "Does your crane have less than 42 ft. of main boom (jibs not permitted)?",
        descrip4: "Does your crane operate only with a remote control?",
        descrip5: "Does your crane have less than 30 ft. of main boom?",
        for5: "For Carry Deck Cranes:",
        descrip6: "Does your crane have less than 50 ft. of main boom?",
        for6: "For Telescopic Boom Cranes (Carry Deck exempt):",
        standardCadInfo: "Based on your responses, you are permitted to use a CCO Standard CAD. Please access the standard CADs through the Practical TSC Resources within the myCCO Testing Personnel Portal",
        standardCadTitle: "Standard CAD Permitted",
        standardCadButton: "Close"
      },
      CustomCAD: {
        pageHeading: "Testing Personnel",
        OptionYes: 'Yes',
        OptionNo: 'No',
        TscPrac: 'TSC-Practical',
        NewCustom: 'New Custom CAD',
        CustomCAD: 'Custom CAD',
        CADDescription: 'CAD Description',
        CADQuestion: 'Use the questions below to determine if a custom CAD is required.',
        CraneType: 'To proceed with Custom CAD, select the Crane type:',
        Next: 'Next',
        CADinfo: 'Information',
        Makefield: 'Make',
        Modelfield: 'Model',
        SerialNumberfield: 'Serial Number',
        MaxRelatedfield: 'Max Rated Capacity (Tons)',
        LATfield: 'What boom length can you set that is between 70-90ft or 110-130ft of main boom?',
        otherfield: 'What is the maximum main boom length?',
        Truckfield: 'Is this a boom truck?',
        SelectOption: ' Select an option',
        OptionNull: 'N/A',
        Workingareafield: 'Working area (degrees)',
        degree: 'degree',
        Cranefield: 'Crane Position',
        behindOption: 'Behind cab',
        CenterOption: 'Center mount',
        RearOption: 'Rear mount',
        FifthOption: 'Fifth wheel',
        Truckfield: 'Truck Bed Length (ft)',
        FrontOutriggerfield: 'Front Outrigger/Stablizer Spread(ft)',
        BackOutriggerfield: 'Back Outrigger/Stablizer Spread(ft)',
        RopeSizefield: 'Rope Size & Type',
        Allowablefield: 'Allowable line pull as stated in the load chart (lb)',
        Diameterfield: 'Diameter of test weight (ft) ',
        UploadLoadChart: 'Upload Load Chart Documentation',
        ClicktoUpload: 'Click to Upload',
        DownloadChart: 'Download Load Chart',
        UploadLinePullChart: 'Upload Line Pull Chart',
        DownloadLinePull: 'Download Line Pull',
        UploadRangeDiagram: ' Upload Range Diagram',
        DownloadRange: ' Download Range Diagram',
        DeliveryType: 'Select which type of delivery method you would like to purchase:',
        StandardType: '- Standard Custom CAD delivery is 5-7 Business Days.',
        RushType: ' - Rush Delivery 2-3 Business Days.',
        SuccessError: "Successfully added Custom CAD.",
        Title: 'Please wait while payment is processed. Do not refresh page or click back button.'
      }
    },

    AvaliableCredential: {
      pageHeading: "Testing Personnel",
      AvailableCredentials: 'Available Credentials',
      NoCredentials: 'No Credentials available',

    },
    NewLocation: {
      Attestation: {
        entry: 'Only Testing Room, with a single point of entry/exit during testing',
        proctor: 'One Proctor Workstation, located in the testing room',
        stations: 'One candidate testing station',
        parking: 'Adequate Parking for the number of vehicles anticipated',
        restroom: 'Restroom is available on-site',
        equipment: 'Candidate/equipment spacing in accordance with CCO policy',
        Attestation: 'Attestation',
        Completed: "Completed",
        InProgress: "In Progress",
        FillFields: 'Please fill out all fields',
        View: 'View',
        NothingSelected: 'Nothing selected',
        Edit: 'Edit',
        station: 'Testing stations and equipment in accordance with CCO policy',
        proctors: 'Dedicated proctor station located in testing room',
        entrys: 'A dedicated, secure testing room, with controlled entry/exit during testing',
        Req: 'Do you have the following requirements?'
      },
      newlocations: {
        Nextstep: "Next step",
        Goback: "Go back",
        Previousstep: "Previous step",
        SubmitApplication: "Submit Application",
        note: "I understand and agree that an application to register a test site cannot be cancelled or transferred, and payments for application fees cannot be refunded, once the application and payment are submitted to CCO. I also declare that the information contained in this application, as well as the information in any required accompanying documentation, is true and correct. I understand that insufficient or inadequate information may result in delays in processing. By submitting a payment, I agree to CCO's",
        FinancialTermsandConditions: "Financial Terms and Conditions",
        AddEOTTestSite: "Add EOT Test Site",


        EOT: "EOT Test Site",
        Adding: "Successfully added the new location",
        saei: 'Save & Exit',
        sa: 'Save changes'



      },
      Summary: {
        Summary: "Summary"

      },
      BillingInfo: {
        Payment: 'Payment',
        FillFields: 'Please fill out all fields',
        View: 'View',
        CardNumber: 'Card Number',
        Completed: "Completed",
        Amount: 'Amount',
        FirstName: 'First Name',
        LastName: 'Last Name',
        Email: 'Email',
        Phone: 'Phone',
        Address: 'Address',
        Country: 'Country',
        City: 'City',
        Zip: 'Zip',
        State: 'State',
        Edit: 'Edit',
        Cardinfo: 'It`s compulsory to fill credit card information first',
        formHeaderText: 'Location Payment',
        billingbuttonText: 'Click here to fill Credit Card Information',
        formbuttonText: 'Continue',
        billinginfo: 'Billing Information',
        billingNote: 'Note: We Accept VISA, MasterCard, and American Express.',
        CardNumber: 'Credit Card Number',
        TypeCreditCard: 'Credit Card',
        Instruction: 'Instructions: Complete the following page using the credit card holder’s information and billing address.'
      },

      TestingFacilityincludingSignage: {
        Photo: "2. Photo of Testing Facility including Signage",
        upload: "Upload Testing Facility Photo",
        picdetail: "5MB max – only .jpeg/.jpg, .png, or .pdf file types supported",
        upload: "Click Here to Upload",
        sampletesting: "Sample Testing Facility Photo",

      },
      TestingSite: {
        TestSiteCapacity: 'Test Site Capacity',
        FillFields: 'Please fill out all fields',
        InProgress: "In Progress",
        View: 'View',

        Edit: 'Edit',
        NoAnswer: 'Not answered',
        Requir: 'Do you have the minimum download/upload speed required?',
        Testingstations: 'Testing stations',
        Completed: "Completed",
        NotCompleted: 'Not completed',
        hA: 'EOT Test Site Internet Requirements (Minimum)',
        para1A: ' Testing Facilities must be able to meet the following technical requirements to be approved for EOT testing:',
        list1: 'Non-Cellular Internet Source (e.g., broadband, cable)',
        list2: 'Recommended download speed of 12 Mbps per device (minimum 2 Mbps)',
        list3: 'Recommended upload speed of 3 Mbps per device (minimum 2 Mbps)',
        Note1A: 'Note: Cellular/mobile hot spots or cellular MiFi devices are not supported.',
        list4: 'Dedicated internet network',
        list5: 'Recommended: hard-wired internet network (Ethernet)',
        list6: 'Minimum: Wireless Internet Network (WiFi)',
        list7: 'Private and Password Protected',
        list8: 'Firewalls Disabled',
        Note2A: 'Note: Public or shared networks are not supported (e.g., hotel public WiFi)..',
        para2A: 'Review the full technical requirements as found in the Test Administration Handbook – EOT Testing, and access online tools to measure the internet speed – ',
        click: 'click here',
        para3A: ' Don’t know your internet speed? Contact testing facility IT support or run a speed test. This link will allow you to run a live speed test:',
        link: "https://www.speedtest.net/",
        performthetest: "Make sure you perform the test in the testing room you plan to use",
        capacity: "B.	Test Site Capacity",
        factors: "Based on all factors, including the available internet speed, internet network and any spacing or equipment limitations, how many candidate testing stations is the facility able to support?",
        attestation3: "C.	Attestation Statement",
        conformation: "I have confirmed that this testing facility meets the EOT Test Site Internet Requirements, and that the internet download/upload speeds will support the number of candidate testing stations entered above.",
        option: "Select an option",
        Yes: "Yes",
        No: "No - Yes is required to submit application",

      },
      TestingRoomLayout: {
        roomlayout: "4. Testing Room Layout",
        upload: "Upload Testing Room Layout",
        picdetail: "10MB max – only .jpeg/.jpg, .png, or .pdf file types supported",
        uploadhere: "Click Here to Upload",
        download: "Download Testing Room Layout Form"
      },

      Representation: {
        representativeInformation: "Test Site Representative Information",
        testingFacility: "The Test Site Representative is the Testing Facility Company Representative. This person authorizes the Test Site Coordinator to set up this test site.",
        name: "Full Name",
        phone: "Mobile Phone",
        email: "Email",
        emailconfirmation: "Email Confirmation",
        uploadtsragreement: "Upload TSR Agreement",
        upload: "Click to Upload",
        maxsizemb: "10MB max (pdf)",
        terms_conditions: "The terms & conditions field is required",
        downloadagreement: "Download Test Site Representative Agreement",
      },
      TestSite: {
        testSite: "1. Test Site Information",
        FacilityTest: "Testing Facility Company Name",
        requireName: "The company name field is required",
        Street1: "Street 1",
        steet1Require: "The street1 field is required",
        street2: "Street 2",
        eg: "(e.g. Suite #, Building #, Room #)",
        country: "Country",
        nocountry: "No countries found. Please try again later.",
        countryRequire: "The country field is required",
        city: "City",
        cityField: "The city field is required",
        state: "State",
        nostates: "No states found. Please try again later.",
        staterequied: "The state field is required",
        zip: "Zip",
        zipRequired: "The zip field is required",
        securefacility: "Is this a secure facility, that has additional access requirements?",
        securerequire: "The secure facility field is required",
        option: "Select an option",
        YES: "Yes",
        NO: "No",
        Timezone: "Timezone",
        timezonerequired: "The timezone field is required",
        notimezone: "No timezone found. Please try again later.",
        Additional: "Please provide additional security instructions that would be required for CCO personnel to access the facility",
        africa: "E. Africa Standard Time",
        hawain: "Hawaiian Standard Time",
        alaskan: "Alaskan Standard Time",
        pacific: "Pacific Standard Time",
        pacificmexico: "Pacific Standard Time (Mexico)",
        us: "US Mountain Standard Time (AZ)",
        mountain: "Mountain Standard Time",
        central: "Central Standard Time",
        eastren: "Eastern Standard Time",
        atlantic: "Atlantic Standard Time",
        west: "West Pacific Standard Time",
        usAz: "US Mountain Standard Time (AZ)",


        selecttz: "Select a timezone",
        selectstate: "Select a state",
        selectcountry: "Select a country",

      },
      STestSiteRepresentativeInformation: {
        testsite: "Test Site Representative Information",
        InProgress: "In Progress",
        FullName: "Full Name",
        fill: "Please fill out all fields",
        View: "View",
        Phone: "Phone",
        Email: "Email",
        Completed: "Completed",
        TSRAgreement: "TSR Agreement",
        Edit: "Edit",
        Notcompleted: "Not completed",

      },
      LocationDoorSign: {
        LocationDoorSign: "Location Door Sign",
        InProgress: "In Progress",
        fill: "Please fill out all fields",
        View: "View",
        Edit: "Edit",
        Completed: "Completed"
      },
      LocationSitePlan: {
        LocationSitePlan: "Location Site Plan",
        fill: "Please fill out all fields",
        InProgress: "In Progress",
        View: "View",
        Completed: "Completed",
        Edit: "Edit"
      },
      LocationInformation: {
        LocationInformation: "Location Information",
        InProgress: "In Progress",
        fill: "Please fill out all fields",
        View: "View",
        CompanyName: "Company Name",
        Street1: "Street 1",
        Street2: "Street 2",
        City: "City",
        Country: "Country",
        Additionalsecurity: "Additional security",
        Zip: "Zip",
        State: "State",
        Country: "Country",
        Securefacility: "Secure facility ?",
        Edit: "Edit",
        Completed: "Completed",
        Notcompleted: "Not completed",
        waiting: "Waiting..."
      }


    },
    GeneratePdf: {
      Sheet: {
        sheet1: "Generate Score Sheet PDFs",
        sheet2: "Generate Signalperson Exam PDF",
        sheet3: "Generate Signalperson CRG PDF"
      },
      Headerpage1: {
        practicalExamScoreSheetDownload: 'Practical Exam Score Sheet Download',
        termsAndConditions: 'By downloading score sheets, you agree to the following terms and conditions:',
        credentialProctor: 'You are a credentialed Practical Exam Proctor with at least one proctor credential designation.',
        scoreSheetRestrictions: 'You may only download score sheets for credential designations that you possess.',
        approved: 'You are approved to administer CCO practical exams.',
        scoreSheetUsage: 'Each score sheet is serialized and can be used only once. You may print them once, and no copies can be made after printing.',
        expirationDetails: 'Each score sheet has an expiration date (top right corner) and may not be used after its expiration date.',
        destructionPolicy: 'Unused (expired) score sheets must be destroyed, and PDF files must be deleted after use.',
        copyrightProtection: 'You understand that the score sheets are protected by federal copyright law.',
        sharingRestriction: 'You will not share this link or any score sheets with anyone. Only you are allowed to handle or submit practical exam candidate score sheets.',
        secureStorageRequirement: 'You will keep all score sheets in a secured location.',
        deletionRequirement: 'You will delete all downloads or destroy any hard copies of score sheets if required to do so by CCO.',
        consequenceAwareness: 'You understand the consequences as outlined in the Practical Exam Proctor Handbook on the custody, care, and control of the score sheets.',
        sanctionAvoidance: 'You are not acting to circumvent the sanction of another Practical Exam Proctor.',
        examAdministration: 'You agree to administer the exams according to CCO policies and procedures.',
        printingRecommendation: 'It is highly recommended that all score sheets be printed double-sided.',
        acknowledgment: 'I acknowledge that I have read and understood the above policies and procedures in their entirety and agree to abide by them. (This box must be checked to place an order.)',
        label: 'Score Sheet Type *',
        dropdownPlaceholder1: 'Select an option',
        label2: 'Quantity *',
        dropdownPlaceholder: 'Select an option',
        dropdown1: "ANCHOR/MICROPILE DRILL RIG",
        dropdown2: "ARTICULATING BOOM CRANE",
        dropdown3: "ARTICULATING BOOM LOADER",
        dropdown4: "CONCRETE PUMP OPERATOR – CLASS 1",
        dropdown5: "CONCRETE PUMP OPERATOR – CLASS 2",
        dropdown6: "DEDICATED PILE DRIVER",
        dropdown7: "DIGGER DERRICK",
        dropdown8: "FOUNDATION DRILL RIG",
        dropdown9: "MCO-LATTICE BOOM CRANE (LAT)",
        dropdown10: "MCO-TELESCOPIC BOOM-SWING CAB (TLL)",
        dropdown11: " MCO-TELESCOPIC BOOM-FIXED CAB (TSS)",
        dropdown12: " OVERHEAD CRANE OPERATOR",
        dropdown13: "RIGGER LEVEL I",
        dropdown14: "RIGGER LEVEL II",
        dropdown15: "SERVICE TRUCK CRANE OPERATOR",
        dropdown16: "SIGNALPERSON",
        dropdown17: "TELEHANDLER OPERATOR - FIXED",
        dropdown18: "TELEHANDLER OPERATOR - ROTATING",
        dropdown19: "TOWER CRANE OPERATOR ",
        back: "Back"

      },
      Headerpage2: {
        signalPerson: "SIGNALPERSON EXAM AND CRG DOWNLOAD",
        agreement: "By downloading the Signalperson Practical Exam and Candidate Response Guide, you agree to the following terms and conditions:",
        credentialPracticalExam: "You are a credentialed Practical Exam Proctor in the Signalperson program.",
        approvalToAdminister: "You are approved to administer Signalperson practical exams.",
        responseGuide: "You understand that the Exam and Candidate Response Guide are protected by federal copyright law.",
        shareLink: "You will not share this link, Exam, or Candidate Response Guide with anyone.",
        CandidateResponse: "You will keep the Exam and Candidate Response Guide in a secured location.",
        copiesOfExam: "You will delete all copies of the Exam and Candidate Response Guide if required to do so by CCO.",
        consequenses: "You understand the consequences as outlined in the Practical Exam Proctor Handbook on the custody, care, and control of the Exam and Candidate Response Guide.",
        practicalExamProtor: "You are not acting to circumvent the sanction of another Practical Exam Proctor.",
        CCOPoliceandProcedure: "You agree to administer the exams according to CCO policies and procedures.",
        acknowledgment: "I acknowledge that I have read and understood the above policies and procedures in their entirety and agree to abide by them."
      },
    },

    EOTComponents: {
      EOTComponent: {
        TestingPersonnel: "Testing Personnel",
        TestSiteLocations: "Test Site Locations",
        CCOID: "CCO ID",
        MyEOTTestSites: "My EOT Test Sites",
        AddnewEOTtestsite: "Add new EOT test site",
        Notestsitesfound: "No test sites found",
        MyPendingPaymentEOTTestSites: "My Pending Payment EOT Test Sites",
        MyPendingReviewEOTTestSites: "My Pending Review EOT Test Sites",
        Notestsitesfound: "No test sites found",
        MyApprovedEOTTestSites: "My Approved EOT Test Sites",
        Notestsitesfound: "No test sites found",
        MyExpiredEOTTestSites: "My Expired EOT Test Sites",
        Notestsitesfound: "No test sites found",
        manageMyTestAdministrations: "Manage My Test Administrations"

      },
      Mainpage: {
        ExpireDate: "Expire Date:",
        View: "View",
        CompanyName: "Company Name",
        Address: "Address",
        Status: "Status",
        ExpireDate: "Expire Date",
        Edit: "Edit",
        RenewNow: "Renew Now"
      }

    },

    Banner: {
      CandidateAccessControl: {
        note: "IMPORTANT: We need your photo! Please submit your selfie now to ensure there are no delays in testing or in the issuance of your certification.",
        red: "Your account is locked. Should you have any questions, please contact Customer Service at candidate@ccocert.org or 703-560-2391",
        orange: "Your account is currently suspended. Some account and related data may still be visible. Should you have any questions, please contact Customer Service at candidate@ccocert.org or 703-560-2391.",
        yellow: "You are currently required to schedule your exam appointment date/time at least two business days in advance. Should you have any questions, please contact Customer Service at candidate@ccocert.org or 703-560-2391."
      },
      testingpersonalBanner: {
        yellow: 'Your testing personnel account is subject to the test administration advanced scheduling requirement. You may only create or be assigned to a test administration with a start date/time at least two business days into the future. Should you have any questions, please contact Testing Personnel Support at testingpersonnel@nccco.org or 703-560-2391 ext. 812.',
        orange: 'Your testing personnel account is currently suspended. Some account and related data may still be visible. Should you have any questions, please contact Testing Personnel Support at testingpersonnel@nccco.org or 703-560-2391 ext. 812.',
        red: 'Your testing personnel account is locked. Should you have any questions, please contact Testing Personnel Support at testingpersonnel@nccco.org or 703-560-2391 ext. 812',
      }
    },

    cards: {
      ContactCredentialCard: {
        Status: "Status",
        TrainingDue: "Training Due",
        Statuses: {
          Pending: "Pending",
          PendingAudit: "Pending Audit",
          Inactive: "Inactive",
          PendingCertification: "Pending Certification",
          Approved: "Approved",
          Expired: "Expired",
          HOLD: "Hold",
          Retired: "Retired",
          PendingRenewal: "Pending Renewal"
        }

      }
    },
    NewPracLocation: {
      LocationInfromation: {
        TestingFacilityCompanyName: "Testing Facility Company Name",
        Street1: "Street 1",
        TestSiteInformation: "Test Site Information",
        Street2: "Street 2",
        str2: "(e.g. Suite #, Building #, Room #)",
        Selectacountry: "Select a country",
        Country: "Country",
        noCountry: "No countries found. Please try again later.",
        City: "City",
        State: "State",
        Selectastate: "Select a state",
        noState: "No states found. Please try again later.",
        Zip: "Zip",
        zipreq: "Is this a secure facility, that has additional access requirements?",
        Selectanoption: "Select an option",
        Yes: "Yes",
        No: "No",
        Timezone: "Timezone",
        Selectatimezone: "Select a timezone",
        Notimezone: "No timezone found. Please try again later.",
        provide: "Please provide additional security instructions that would be required for CCO personnel to access the facility"


      },
      newpracloc: {
        PracticalTestSite: "Practical Test Site",
        AddPracticalTestSite: "Add Practical Test Site",
        note: "I understand and agree that an application to register a test site cannot be cancelled or transferred, and payments for application fees cannot be refunded, once the application and payment are submitted to CCO. I also declare that the information contained in this application, as well as the information in any required accompanying documentation, is true and correct. I understand that insufficient or inadequate information may result in delays in processing. By submitting a payment, I agree to CCO's.",
        note2: "Financial Terms and Conditions",
        added: "Successfully added the new location",
        back: 'Go back',
        step: 'Previous step',
        Submit: "Submit Application",
        next: 'Next step',
        sa: 'Save changes',
        saei: 'Save & Exit',
        wait: 'Updating please wait...',
        plz: 'Please wait while submission is processing. Do not click Back or Refresh.',
        networkError: "Please resubmit the form. Due to a network issue, the form was not submitted.",


      },
      locationDoorSign: {
        photo: "Photo of Testing Facility including Signage",
        upphoto: "Upload Testing Facility Photo",
        mb: "5MB max",
        upload: "Click Here to Upload",
        sample: "Sample Testing Facility Photo",

        CourseArea: "Practical Testing Course Area Photo",
        uploadphoto: "Upload Photo of Practical Test Area",
        mb: "10MB max",
        upload: "Click Here to Upload",
      },
      Examofferd: {
        PracticalExams: "Practical Exams Offered",
        select: "Please select the CCO practical exams you plan to offer at this test site.",
        note: "I understand and acknowledge that CCO has established unique and specific criteria for each practical exam type and the related equipment to be used for testing, which may include but is not limited to, the testing area size, testing area surface, levelness of the ground, proximity to obstructions and hazards and that the equipment to be used for testing is compliant with all applicable industry and manufacturer standard(s). I attest that I have read and familiarized myself with CCO's criteria for Practical Test Sites, as set forth in the Test Administration Handbook - Practical and agree to prepare this Test Site and related equipment in accordance with the stated requirements. I furthermore attest that the testing course is free of all training aides and training/reference materials."

      },
      TestSiteRepresentativeInfo: {
        TestSiteRepresentativeInformation: "Test Site Representative Information",
        note: "The Test Site Representative is the Testing Facility Company Representative. This person authorizes the Test Site Coordinator to set up this test site.",
        FullName: "Full Name",
        MobilePhone: "Mobile Phone ",
        Email: "Email",
        EmailConfirmation: "Email Confirmation",
        UploadTSR: "Upload TSR Agreement",
        mb: "10MB max (pdf)",
        btn: "Click to Upload",
        download: "Download Test Site Representative Agreement"
      },
      Attestation: {
        Attestation: "Attestation",
        req: "Do you have the following requirements?",
        ade: "Adequate parking for the number of anticipated vehicles",
        availible: "Restrooms available on-site",
        pretest: " A pre-test briefing area for candidates waiting to test (unable to observe candidates who are live testing)",

      },
      BillingInformation: {
        BillingInformation: " Billing Information",
        note: "Note: We Accept VISA, MasterCard, and American Express.",
        note2: "It's compulsory to fill credit card information first",
        FirstName: "First Name",
        LastName: "Last Name",
        Email: "Email",
        Phone: "Phone ",
        Country: "Country",
        Address: "Address",
        City: "City",
        State: "State",
        Zip: "Zip",
        btn1: "Click here to fill Credit Card Information",
        Continue: "Continue",
        LocationPayment: "Location Payment"


      }
    },
    SummaryPracSite: {
      LocationInformation: {
        LocationInformation: "Location Information",
        com: "Completed",
        inprog: "In Progress",
        note: "Please fill out all fields",
        View: "View",
        CompanyName: "Company Name",
        Street1: "Street 1",
        Street2: "Street 2",
        City: "City",
        Zip: "Zip",
        State: "State",
        Country: "Country",
        fac: "Secure facility ?",
        sec: "Additional security",
        Notcompleted: "Not completed",
        waiting: "Waiting...",
        Yes: "Yes",
        No: "No",
        Edit: "Edit"
      },
      LocationDoorSign: {
        LocationDoorSign: "Location Door Sign",
        com: "Completed",
        inprog: "In Progress",
        note: "Please fill out all fields",
        sup: "File type not supported",
        View: "View",
        Edit: " Edit",
      },
      PracticalTesting: {
        PracticalTesting: "Practical Testing Course Area Photo",
        com: "Completed",
        inprog: "In Progress",
        note: "Please fill out all fields",
        pracArea: "Photo of Practical Test Area",
        Edit: "Edit"

      },
      PracticalExamOffered: {
        PracticalExamOffered: "Practical Exam Offered",
        com: "Completed",
        inprog: "In Progress",
        View: "View",
        note: "Please fill out all fields",
        Nothingselected: "Nothing selected",
        Attes: "Is Practical Attestation",
        Edit: "Edit"

      },
      TestSite: {
        TestSite: "Test Site Representative Information",
        com: "Completed",
        inprog: "In Progress",
        View: "View",
        note: "Please fill out all fields",
        FullName: "Full Name",
        Phone: "Phone",
        Email: "Email",
        TSR: "TSR Agreement",
        Edit: "Edit",
        notcom: 'Not completed'
      },
      Attestation: {
        Attestation: "Attestation",
        com: "Completed",
        inprog: "In Progress",
        View: "View",
        note: "Please fill out all fields",
        no: "Nothing selected",
        Edit: " Edit"
      },
      Payment: {
        Payment: "Payment",
        com: "Completed",
        inprog: "In Progress",
        View: "View",
        note: "Please fill out all fields",
        CardNumber: "Card Number",
        Amount: "Amount",
        FirstName: "First Name",
        LastName: "Last Name",
        Email: "Email",
        Phone: "Phone",
        Address: "Address",
        Country: "Country",
        City: "City",
        State: "State",
        Edit: "Edit"

      },
      Summary: {
        Summary: "Summary"
      }

    },

    login: {
      login: {
        login: "Welcome to the myCCO Portal!",
        reg: "Login or register for a myCCO Portal account to:",
        submit: "Submit an exam application",
        update: "Update your contact information",
        exam: "See exam results and current certifications",
        create: "Create an account in just a few easy steps. Watch a step-by-step video on how to register as an",
        candidate: "existing candidate",
        msg: "(someone who has tested with CCO in the past or is certified) or a ",
        user: "new user",

      }
    },


    PhotoManagement: {
      PhotoIDUpload: {
        PhotoManagement: "Submit your Photo",
        Submission: "Submit your government-issued ID photo",
        Eg: "(e.g., Driver's License, Passport)",
        Note: "NOTE: Your ID will be used to validate your identity and will be",
        permanentlydeleted: "permanently deleted",
        Verified: "once verified.",
        UpdatePhoto: "Update Photo",
        Upload: "Upload Photo of ID",
        Webcam: "Use Camera",
        Rotate: "Rotate",
        ZoomIn: "Zoom In",
        ZoomOut: "Zoom Out",
        Remove: "Remove",
        Reset: "Reset",
        Image: "Select Image",
        ID: "Make sure your photo meets CCO guidelines",
        Capture: "Capture",
        Close: "Close",
        DragDrop: "Click or Drag and Drop here",
        QuickGuidelines: "Quick Guidelines",
        Rule1: "Valid, government-issued",
        Rule2: "Full name & DOB clearly visible",
        Rule3: "No redacted or covered parts",
        Rule4: "No chopped corners or glare",
        Acceptable: "Acceptable",
        CheckGuidelines: "Click here for photo ID submission guidelines"
      },
      PhotoManagement: {
        PhotoManagement: "Submit your Photo",
        Dashboard: "Dashboard",
        Request: "The request has already been submitted. Please contact CCO if you have any questions.",
        Record: "Our records indicate that you are not authorized to access this page. Please contact CCO if you have any questions.",
        Submission: "Submit your photo and your government-issued ID",
        Success: "Your account updated successfully, click Return to Dashboard button to continue.",
        Return: "Return to Dashboard",
        error: "Please upload only image files with the following formats: JPEG, JPG, PNG.",
        Submitting: "Submitting...",
        Submit: "Submit Photo",
        Waiting: "Please wait while your submission is processed. Do not refresh page or click the back button.",
        incompleteProfile: 'Your account details are not yet complete. You can upload your photo now, but please complete your account details to unlock all features.',
        Photo: "Photo",
        IDLink: "ID Link",
        Review: "Review",
        clickhere: "Click here for photo submission guidelines",
        Previous: "Previous",
        Next: "Next",
        OR: "OR",
        Close: "Close",
        OverviewTitle: "Let's verify your identity",
        OverviewDesc: "As a myCCO user, you are required to provide a selfie and verify your identity. We recommend doing this process with a smartphone.",
        IdentityVerification: "Identity Verification",
        SelfiePhotoTitle: "A selfie photo",
        SelfiePhotoSub: "Taken live using your camera",
        PhotoIDTitle: "A photo ID",
        PhotoIDSub: "Passport, driver's license, or national ID",
        PrivacyNote: "Your Photo ID will be used to validate your identity and will be",
        PermanentlyDeleted: "permanently deleted",
        OnceVerified: "once verified.",
        ContinueBtn: "Continue →",
      },
      PhotoUpload: {
        TakePhoto: "Take a Photo",
        Submission: "Submit Your Passport-style Photo",
        Eg: "(color photo, solid background, no hats, no sunglasses, no filters)",
        Note: "NOTE: This photo will be used for your certification card once certification has been earned.",
        Update: "Update Photo",
        Upload: "Upload Profile Photo",
        Webcam: "Use Camera",
        Rotate: "Rotate",
        ZoomIn: "Zoom In",
        ZoomOut: "Zoom Out",
        Remove: "Remove",
        Image: "Select Image",
        Reset: "Reset",
        Submit: "Click here for photo submission guidelines",
        Capture: "Capture",
        Close: "Close",
        PhotoRec: "Face not detected. Please provide an image with a visible face.",
        DragDrop: "Click or Drag and Drop here",
        QuickGuidelines: "Quick Guidelines",
        Rule1: "Solid light background",
        Rule2: "Face centered, natural look",
        Rule3: "No hats or sunglasses",
        Rule4: "No filters or dark shadows",
        Acceptable: "Acceptable"
      },
      errors: {
        unableToVerify: "Unable to verify. Please retake.",
        noFaceDetected: "No face detected. Please retake your selfie.",
        verificationError: "An error occurred during selfie verification. Please try again.",
        aiDisclaimer: "NOTE: AI can make mistakes. You may continue if error message seems incorrect.",
      },
      validationErrors: {
        NoImageData: "No image data received. Please try again.",
        VerificationFailed: "Verification failed. Please try again.",
        NoFaceDetected: "No face detected.",
        HeadCutOff: "Top of head cut off. Align with head frame.",
        ChinCutOff: "Bottom of face cut off. Align with head frame.",
        FaceTooClose: "Face is too close to camera. Align with head frame.",
        TooFarAway: "Too far away. Align with head frame.",
        TooMuchSpaceAbove: "Not properly centered. Align with head frame.",
        FaceNotCentered: "Not properly centered. Align with head frame.",
        TorsoVisible: "Too far away. Align with head frame.",
        ImageBlurry: "Image appears blurry or poor lighting. Find better lighting and hold camera steady.",
        HeadwearDetected: "Hat/head covering detected. Remove.",
        SunglassesDetected: "Sunglasses detected. Remove.",
        FaceNotVisible: "Make sure face is visible.",
        NotLookingAtCamera: "Look directly at camera.",
        NoFaceOnID: "No face detected on photo ID. Ensure photo ID clearly shows your face.",
        IDVerificationFailed: "ID verification failed. Please try again.",
        BackgroundTooBusy: "Background appears too busy or cluttered. Use plain white background.",
      },
      steps: {
        overview: "OVERVIEW",
        selfieTips: "SELFIE TIPS",
        takeSelfie: "TAKE SELFIE",
        idTips: "ID TIPS",
        takeIdPhoto: "TAKE ID PHOTO",
        reviewSubmit: "REVIEW & SUBMIT",
        complete: "COMPLETE",
      },
      badge: {
        do: "DO",
        dont: "DON'T",
      },
      header: {
        secureTagline: "Secure · Encrypted · Private · Professional",
        secureTaglineMobile: "Secure · Encrypted · Private",
        stepOf: "Step {{step}} of 7",
        stepOfMobile: "{{step}} / 7",
      },
      selfieGuidelines: {
        title: "Selfie guidelines",
        subtitle: "Make sure your selfie meets these requirements for smooth verification.",
        acceptable: "Acceptable",
        doLabel: "DO",
        do: {
          faceVisible: "Face clearly visible",
          faceVisibleTip: "Center your face, eyes open, neutral expression",
          goodLighting: "Good lighting",
          goodLightingTip: "Face should be evenly lit with no harsh shadows",
          headShoulders: "Head & shoulders visible",
          headShouldersTip: "Include your full head and upper shoulders",
          plainBackground: "Plain background",
          plainBackgroundTip: "Use a plain wall or solid-color background",
        },
        dont: {
          notCentered: "Not centered or head cut off",
          notCenteredTip: "Keep your full face centered in the frame",
          noHat: "No hat, no sunglasses",
          noHatTip: "Remove hats & glasses for clear ID matching",
          notBlurry: "Not blurry or low quality",
          notBlurryTip: "Hold still and ensure your camera is in focus",
          noBusyBackground: "No busy background",
          noBusyBackgroundTip: "Move to a plain wall or solid background",
        },
      },
      idGuidelines: {
        title: "Photo ID Guidelines",
        subtitle: "We accept passports, driver's licenses, and national IDs.",
        acceptable: "Acceptable",
        entireCardVisible: "← Entire card must be visible →",
        fullCardVisible: "← Full card visible →",
        doLabel: "DO",
        do: {
          fullIdVisible: "Full ID visible",
          fullIdVisibleTip: "All four corners of your ID must be in frame",
          expiryDateClear: "Expiry date clear",
          expiryDateClearTip: "Expiration date must be legible and not expired",
          dateOfBirthVisible: "Date of birth visible",
          dateOfBirthVisibleTip: "Your date of birth must match myCCO records",
          wellLit: "Well lit, no glare",
          wellLitTip: "Ensure even lighting with no flash glare or shadows",
        },
        requiredLabel: "Required:",
        requiredFieldsLabel: "Required fields:",
        requiredFields: "Full name · Date of birth · Expiration date · Photo",
        dont: {
          notCropped: "Not cropped",
          notCroppedTip: "All four corners of your ID must be visible",
          notBlurry: "Not blurry",
          notBlurryTip: "Hold still and ensure the image is in focus",
          dontCoverText: "Don't cover text",
          dontCoverTextTip: "Ensure name, photo and DOB are fully visible",
          mustBeOfficial: "Must be official ID",
          mustBeOfficialTip: "Use government-issued ID only",
        },
      },
      bypass: {
        reasonLabel: "Our AI-enabled technology is detecting that your photo does not meet CCO requirements. However, AI can make mistakes. To help us make improvements, please provide the reason you want to continue in spite of the error(s) shown.",
        reasonPlaceholder: "Reason required (max 100 characters)",
        continueButton: "Continue Anyway",
        backButton: "Go Back & Retake",
      },
      selfieCamera: {
        title: "Review your Selfie",
        subtitle: "Position your face in the oval and ensure good lighting.",
        captured: "✓ Captured",
        capturedWithErrors: "✗ Error Detected",
        capturedHint: "Selfie captured ✓",
        retakeSelfie: "🔄 Retake Selfie",
        cameraLabel: "Selfie",
      },
      idCamera: {
        title: "Review Photo ID",
        subtitle: "Place your ID on a flat, dark surface and capture the full card.",
        photographTitle: "Photograph your ID",
        photographSubtitle: "Position your ID within the frame and ensure it's fully readable.",
        captured: "✓ Captured",
        capturedWithErrors: "✗ Error Detected",
        capturedHint: "ID photo captured ✓",
        retakePhoto: "🔄 Retake Photo",
        alignHint: "Align ID within frame",
        landscape: "⬛ Landscape",
        portrait: "▮ Portrait",
        cameraLabel: "ID Card",
      },
      review: {
        title: "Review & submit",
        subtitle: "Check both photos before submitting. Make sure they're clear and complete.",
        selfieLabel: "🤳 Selfie",
        idLabel: "🪪 Photo ID",
        ready: "✓ READY",
        readyMobile: "✓ Ready",
        errorBadge: "⚠ Bypassed",
        retakeSelfie: "🔄 Retake Selfie",
        retakePhoto: "🔄 Retake Photo",
        bypassReasonLabel: "Bypass reason:",
        bypassReasonEdit: "Edit reason",
        submitBtn: "🚀 Submit Verification",
        submitting: "🚀 Submitting…",
      },
      success: {
        title: "Submission received!",
        desc: "We're reviewing your submission. You'll be notified once verified – allow up to two (2) business days.",
        selfieTag: "Selfie ✓",
        idPhotoTag: "ID Photo ✓",
        returnBtn: "Return to Dashboard",
      },
      nav: {
        back: "← Back",
        backToSelfie: "← Back to Selfie",
        continueToCamera: "Continue to Camera",
        continue: "Continue →",
        review: "Review →",
        takeSelfie: "Take Selfie",
      },
    },
    Footer: {
      Footer: "Copyright 2022-{{year}}. All rights reserved."
    },

    CardOrder: {
      headerDashboard: "Dashboard",
      headerCardOrder: "Wallet Card Order",
      notEligible: "Our records indicate that you are not authorized to access this page. Please contact CCO if you have any questions.",
      subheading: "CCO Replacement Wallet Card Order Form",
      walletCostNote: "Certified individuals receive a laminated CCO wallet card at no cost when they complete initial certification, or recertification. If needed, replacement cards may be ordered online at a cost of $30. Orders are processed upon receipt, please allow up to three weeks for delivery.",
      shippingInformation: {
        title: "Shipping Information",
        shippingCheck: "Use my mailing address on file.",
        Attention: "Attention",
        Street1: "Street 1",
        Street2: "Street 2",
        city: "City",
        zip: "Zip",
        note: "Note : If you need to update your mailing address, go to ",
        noteLink: "account details",
        nextButton: "Next"
      },
      billingInformation: {
        title: "Billing Information",
        note: "Note: We Accept VISA, MasterCard, and American Express.",
        cardNumber: "Credit Card Number",
        hostedFormText: "Click here to fill Credit Card Information",
        formHeaderText: "Wallet Card Order Payment",
        CreditInfo: "Please fill credit card information!",
        formButtonText: "Continue",
        FirstName: "First Name",
        LastName: "Last Name",
        Email: "Email",
        Phone: "Phone",
        Country: "Country",
        Address: "Address",
        City: "City",
        State: "State",
        Zip: "Zip",
        requestSuccess: "Request submited successfully.",
        payButton: "Pay"
      },
      loadingMessage: "Please wait while your order is processed. Do not refresh page or click back button.",
    },
 
    TransactionModal: {
      transactionComplete: "Transaction Complete",
      transactionButton: "Ok"
    },
    modal: {
      errorTitle: "Missing Required Information",
      apiErrorTitle: "Error",
      errorMessageSingular: "The {{fields}} field is required. Please fill it to save changes.",
      errorMessagePlural: "The {{fields}} fields are required. Please fill them to save changes.",
      close: "Close"
    },
    fields: {
      zip: "Zip",
      zipcode: "Zip",
      countryid: "Country",
      country: "Country",
      email: "Email",
      city: "City",
      stateid: "State",
      stateid: "State",
      phone: "Phone",
      state: "state",
      languagepreference: "Language Preference",
      street1: "Street Address",
      address1: "Street1",
      name: " Display Name",
      type: "Type",
      othertype: "Other Type",
      legalname: " Legal Name",
      websiteurl: "Website/URL",

    },
    AuthorizeSessionTimer: {
      title: "Time Remaining:"
    }

    , MyCCOPro: {
      breadcrumb: "CCO Pro",
      testingPersonnel: "Testing Personnel",
      introText: "CCO now offers organizations the ability to manage their candidates through myCCO. They can monitor their certifications and receive alerts about the status of those certifications. To begin, submit a new organization request. All requests are reviewed by CCO to ensure compliance with our policies.",
      certConnectDescriptionPart1: "Welcome to the CCO Pro Portal—your hub for interacting with CCO at an organizational level. The CCO Pro portal is launching CertConnect, a tool giving organizations the ability to monitor and receive alerts about the status of personnel certifications. Among other things, CertConnect can help your organization monitor certification compliance. Access to certification information is subject to the consent of each connection. To begin, submit a new organization request. All submissions are reviewed to ensure compliance with CCO policies and the ",
      certConnectDescriptionLinkText: "Program Participant Agreement",
      certConnectDescriptionPart2: ". Once approved, you’ll be able to request connections and begin monitoring certifications more effectively than ever.",
      myOrganizations: "My Organizations",
      addNewOrganization: "Add new Organization",
      myPendingApprovalOrgs: "My Pending Approval Organizations",
      organizationName: "Organization Name",
      address: "Address",
      status: "Status",
      view: "View",
      myApprovedOrgs: "My Approved Organizations",
      open: "Open",
      OrgId: "Org ID",
      CCOID: 'CCO ID',
      Pagination: {
        rowsPerPage: "Rows per page:",
        first: "« First",
        firstMobile: "First",
        previous: "‹ Previous",
        previousMobile: "Previous",
        next: "Next ›",
        nextMobile: "Next",
        last: "Last »",
        lastMobile: "Last",
      },
      CreateOrg: {
        breadcrumb: "Create Organization",
        displayName: "Organization Display Name",
        orgType: "Organization Type",
        otherType: "Other Type",
        legalName: "Organization Legal Name",
        website: "Organization Website/URL",
        street1: "Street 1",
        street2: "Street 2",
        country: "Country",
        city: "City",
        state: "State",
        zipCode: "Zip Code",
        extraDetails: "Additional Details Regarding Your Request",
        submit: "Submit",
        pleaseWait: "Please wait while your organization is being created. Do not refresh the page or click the back button.",
        loading: "Loading...",
        selectType: "Select an Organization Type",
        orgTypes: {
          Employer: "Employer",
          Insurer: "Insurer",
          Other: "Other",
          "Regulatory Body": "Regulatory Body",
          "Site Owner": "Site Owner",
          "Training Provider": "Training Provider",
          Union: "Union",

        },
        update: ' Update Organization',
        saving: "Saving...",
        update: "Update Organization"
      },


      DetailPage: {
        breadcrumb: "Organization Detail",
        heading: "My Organizations",
        edit: "Edit",
        companyNamePlaceholder: "[Company Name]",
        addressSeparator: " - ",
        ccoidLabel: "CCOID",
        loading: "Loading organization details...",
        error: "Failed to load organization details.",

        certConnectDescriptionPart1: "CertConnect gives your organization the ability to monitor and receive alerts about the status of personnel certifications, subject to the consent of each connection. This tool should not be used to recruit individuals. As an approved organization, you will be able to see your connections’ certification status, but not their exam history or results. All CertConnect activities are subject to CCO policies and the ",
        certConnectDescriptionLinkText: "Program Participant Agreement",
        certConnectDescriptionPart2: ".",
        certConnectDescriptionPart3: "For immediate assistance with CertConnect, please email",
        certConnectDescriptionPart4: "or call 703-560-2391 ext. 944.",


      },
      OrganizationConnections: {
        manageConnectionsPrompt: "Want to manage your connections?",
        viewOrganizationConnectionsLink: "View My Organization Connections",
        Title: "My Organization Connections",
        NoConnections: "No organization connections found.",
        OrganizationName: "Organization Name",
        Address: "Address",
        NoAddress: "[No address available]",
        Status: "Status",
        Remove: "Remove",
        Approve: "Approve",
        Deny: "Deny",
        Close: "Close",
        certConnectCandidateDescriptionPart1: "With your express approval and consent, CertConnect can give an organization (such as an employer) the ability to monitor and receive alerts about the status of your certifications. Approved organizations will be able to see and share your certification status, but they will not see your exam history or results. You can remove a connection at any time. All CertConnect activities are subject to CCO policies and the ",
        certConnectCandidateDescriptionLinkText: "Program Participant Agreement",
        certConnectCandidateDescriptionPart2: ".",
        RequestApproved: "The request has been approved.",
        RequestDenied: "The request has been denied.",
        RequestRemoved: "The request has been removed.",
        RequestApprovalError: "An error occurred while processing the request.",
        RequestRemovalError: "Failed to remove the request."
      },
      SearchCandidate: {
        addCandidates: 'To add connections, use the search',
        enterId: 'Enter your CCO ID:',
        enterIdPlaceholder: 'Enter CCO ID',
        search: 'Search',
        incompleteProfile: '{{name}} has not completed their profile and must complete it in their myCCO portal to be added.',
        missingPhoto: '{{name}} does not have an approved photo and must submit one in their myCCO portal to be added.',
        isAccessLocked: '{{name}} account is locked and cannot be added at this time. Contact CCO at 703-560-2391 if you have questions.',
        requestSent: 'Request sent',
        alreadyExists: 'A certification request already exists for candidate {{name}} in this organization.',
        ok: 'OK',
        myConnections: 'My Connections',
        email: 'Email',
        name: 'Name',
        certificationsHeld: 'Certifications Held',
        ccoId: 'CCO ID',
        status: 'Status',
        "Statuses": {
          "Active": "Active",
          "Suspended": "Suspended",
          "Revoked": "Revoked",
          "Inactive": "Inactive",
          "Approved": "Approved",
          "Pending": "Pendiente",
          "PendingRecert": "Pending Recert",
          "Expired": "Expirado"
        },
        designation: 'Certification',
        expiration: 'Exp Date',
        remove: 'Remove',
        actionComplete: 'Action Completed',
        requesting: 'Requesting...',
        requestAccess: 'Request to Connect',
        nameUnavailable: 'Name not available',
        notAvailable: 'Not available',
        pendingError: 'Pending Connection Approval',
        mobile: 'Mobile No',
        modalerror: 'Item has been removed successfully!',
        accounterror: 'Account Locked, Contact CCO at 703-560-2391',
        IsApprovedPhotoError: "Candidate must upload photo on myCCO portal",
        lockerror: "Account Locked",
        edit: "Edit",
        remove: "Remove",
        editNoteAvailability: "Edit Note & Availability",
        available: "Available",
        note: "Note",
        cancel: "Cancel",
        save: "Save",
        saving: "Saving...",
        myConnections: "My Connections",
        enterNameOrCCOID: "Search by Name or CCOID",
        selectView: "Select View",
        sort: "Sort",
        field: "Field",
        name: "Name",
        ccoid: "CCOID",
        ascending: "↑ Ascending",
        descending: "↓ Descending",
        rowsPerPage: "Rows per page:",
        designationHeld: "Designation Held",
        none: "No Certifications",
        photoNotApproved: "Photo Missing",
        recordsperpage: "Records Per Page",
        filter: {
          button: "Filter",
          title: "Filters",
          reset: "Reset",
          designations: "Designations",
          matchMode: "Match Mode",
          matchAny: "Any selected can match",
          matchAll: "All selected must match",
          availability: "Availability",
          availabilityOptions: {
            all: "All",
            available: "Available",
            notAvailable: "Not",
          },
        },
        sort: "Sort",
        field: "Field",
        name: "Name",
        ccoid: "CCO ID",
        ascending: "Ascending",
        descending: "Descending",
        apply: "Apply Filters",
        applysort: "Apply",
        nodesignations: "No designations found",
        searchdesignation: 'Search designations...',
        Labels: {
          designation: "Designation:",
          availability: "Availability:",
          matchMode: "Match Mode:",
          sortBy: "Sort By:",
          reset: "Reset",
          any: "ANY",
          all: "All",
          available: "Available",
          notAvailable: "Not",
          asc: "Asc",
          desc: "Desc",
          noConnections: "No connections found",
        },
      }
      , OrganizationDetails: {
        breadcrumb: "Organization Details",
        information: "Organization Information",
        edit: "Edit",
        section1: "1. Location Information",
        section2: "2. Other Organization Manager",
        view: "View",
        notCompleted: "Not completed",
        waiting: "waiting",
        fields: {
          orgName: "Organization Name",
          legalName: "Legal Name",
          website: "Website",
          type: "Type",
          otherType: "Other Type",
          street1: "Street 1",
          street2: "Street 2",
          city: "City",
          state: "State",
          zip: "Zip",
          country: "Country",
          primary: "Primary",
          addManager: "Edit",
        },
        AddManagers: {
          title: "Add other Organization Managers",
          searchLabel: "Search by Email",
          searchHint: "Enter the email address to search (exact match).",
          searchPlaceholder: "Enter email address",
          searching: "Searching...",
          noMatchFound: "No exact match found.",
          adding: "Adding Organization Manager...",
          success: "Organization Manager added!",
          select: "Select",
          selectedLabel: "Selected Organization Manager",
          primary: "Primary",
          setPrimary: "Set Primary",
          remove: "Remove",
          noneSelected: "No other Organization Manager selected",
          back: "Save"
        }
      }
      ,
      myOrgCard: {
        OrgId: "Org Id",
        Address: "Address",
        Status: "Status",
        Statuses: {
          Approved: "Approved",
          Pending: "Pending",
          Inactive: "Inactive",
          Active: "Active",
          Denied: "Denied"

        }
      }

    },
    organization: {
      errors: {
        duplicateNameLegal: "An organization with the same Name and Legal Name already exists.",
        duplicateName: "An organization with the same Name already exists.",
        duplicateLegalName: "An organization with the same Legal Name already exists.",
        genericError: "Something went wrong. Please try again.",
        maxOrgManager: "This user has already reached maximum allowed organization manager positions.",
      },
      validation: {
        required: {
          name: "Organization Name is required",
          city: "City is required",
          street1: "Street address is required",
          zipCode: "ZIP Code is required",
          state: "State is required",
          country: "Country is required",
          type: "Organization type is required",
          otherType: "Other Type is required",
          legalName: "Legal Name is required",
          website: "Website is required",
        },
        url: "Please enter a valid URL",
      },
      err: {
        maxOrgManager: "This user has already reached maximum allowed organization manager positions.",
        unexpected: "An unexpected error occurred. Please try again later."
      },
    },
    contact: {
      errors: {
        invalidCcoId: "Invalid CCO ID provided.",
        notFound: "Contact not found. Please try again.",
        duplicateCertRequest: "A certification request already exists for this candidate in this organization.",
        incompleteProfile: "{{name}} has not completed their profile and must complete it in their myCCO portal to be added.",
        noPhoto: "{{name}} does not have an approved photo and must submit one in their myCCO portal to be added.",
        lockedAccount: "{{name}} account is locked and cannot be added at this time. Contact CCO at 703-560-2391 if you have questions.",
        genericError: "Something went wrong. Please try again later.",
      },
    },

    // Credentials:{
    //   Mycredential:{
    //     OpenOnlineLearningCenter: "Open Online Learning Center",
    //     manageMyTestAdministrations:"manageMyTestAdministrationsUrl",
    //     Resources:"Resources",
    //     TSCEOT:"TSC-EOT",


    //   }
    // }

    bulkUpload: {

      BulkUpload: "Bulk Upload",
      Total: "Total",
      Name: "Name",
      EligibleToConnect: "Eligible To Connect?",
      Eligible: "Eligible",
      NotEligible: "Not Eligible",
      MissingPhoto: "Missing Photo",
      CheckEligibility: "Check Eligibility",
      FilterEligible: "Show Eligible Only",
      RequestAllEligible: "Request Eligible Connections",
      Eligibility: "Eligibility",
      Checking: "Checking...",
      Requesting: "Requesting...",
      NoDataAvailable: "No data available.",
      ccoId: "CCO ID",
      accountLocked: "Account is locked",
      AlreadyhasRequest: "Duplicate Connection Request.",
      requestSent: "Request Sent!",
      success: "Success",
      contactNotFound: "Contact Not Found",
      OrgNotFound: "Organization not found.",
      Title: "⚠️Too Many Records",
      Text: "More than 500 records are not allowed!",
      Note: "Note:There is a",
      Record: "500 record limit per upload",
      ChooseFile: "Choose File",
      GuideLine: "submission guidelines",
      Instructions: "With Bulk Upload, you can send multiple CertConnect requests at once. View the",
      InstructionCont: "here to ensure the file upload is successful.",
      InvalidFile: "Invalid File",
      ColumnHeader: "Some columns contain data but do not have a header.",
      SameRow: "All columns must start with data on the same row.",
      OnlyFilesAllowed: "Acceptable file formats: ",
      ExportResults: "Export Results",
      ProfileIsIncomplete: "myCCO Profile incomplete.",
      And: "and",
      Only: "only",
      UseBulkUpload: "use bulk upload",
      ForLargeGroups: "For large groups",
      BulkUploadData: "CCO CertConnect Bulk Upload Results",
      Yes: "Yes",
    },
    dataGrid: {
      Fields: {
        FirstName: "First Name",
        LastName: "Last Name",
        CCOID: "CCO ID",
        Designation: "Designation",
        Availability: "Availability",
        ExpDate: "Exp Date",
        Note: "Note",
        ActionRequired: "Action Required",
        Available: "Available",
      },
      Operators: {
        contains: "contains",
        MatchAny: "Match Any",
        MatchAll: "Match All",
        Is: "Is",
        On: "On",
        OnOrBefore: "On Or Before",
        OnOrAfter: "On Or After",
      },
      CertifiedConnections: "Certified Connections",
      NeedsAttention: "Needs Attention",
      Certified: "Certified",
      NoFilters: "No Filters",
      FilterRecords: "Filter Records",
      NofiltersTxt: "No filters applied.Click \"Add Filter\" to create one.",
      AddFilter: "Add Filter",
      ClearAll: "Clear All",
      Apply: "Apply",
      Close: "Close",
      SearcboxNeed: "Search Name/CCO ID",
      SearchCertified: "Search Name/CCO ID/Note",
      Reset: "Reset",
      RowsPerPage: "Rows per page:",
      NoRowsLabel: "No connections available.",
      FirstName: "First Name",
      MI: "MI",
      LastName: "Last Name",
      CCOID: "CCO ID",
      Designation: "Designation",
      Availability: "Availability",
      ExpDate: "Exp Date",
      Note: "Note",
      ActionRequired: "Action Required",
      Available: "Available",
      Not: "Not",
      accountLocked: "Account Locked",
      pendingConnectionApproval: "Pending Connection Approval",
      noCertifications: "No Certifications",
      missingPhoto: "Missing Photo",
      contains: "contains",
      MatchAny: "Match Any",
      MatchAll: "Match All",
      Is: "Is",
      On: "On",
      OnOrBefore: "On Or Before",
      OnOrAfter: "On Or After",
      Field: "Field",
      Operator: "Operator",
      Value: "Value",
      EnterValue: "Enter Value...",
      All: "All",
      NotAvailable: "Not Available",
      SelectDesignations: "Select designations...",
      Status: "Status",
      Select: "Select",
      PendingConnection: "PendingConnection",
      ResultsCount: "Results Count: {{count}}",
      DesignationModal: {
        NoDesignationsFound: "No designations found",
        SearchDesignation: "Search Designation",
        Apply: "Apply",
      },
      FilterApplied: "{{count}} filter(s) applied",
      Rows: "Rows:",
      Date: "Date"
    },


  },



};
export default English;



























